// 真实扫码从调起到出结果不可能快于该时长，早于此到达的回调视为客户端桥接误触发
const SCAN_MIN_DURATION = 1000;

// 安卓与 iOS 的桥接时序差异明显，调起与返回策略需区分处理
function isIOS() {
  return /iphone|ipad|ipod/i.test(navigator.userAgent);
}
export default {
  data() {
    return {
      scanStartedAt: 0,
      scanRetried: false,
      visibleTimer: null,
      returning: false
    };
  },
  mounted() {
    // 仅 iOS 依赖可见性自动返回。安卓走“调起后入队返回”路径，页面在扫码
    // 结束时即被关闭，无需该监听
    if (isIOS()) {
      // 扫码/收银原生界面盖住 web-view 期间页面不可见，重新可见并稳定后即
      // 代表整个扫码付款交互结束，此时页面栈完好，自动返回无时序竞争。
      // 若个别 iOS 版本不触发该事件，则退化为手动点“已完成扫码”返回
      document.addEventListener('visibilitychange', this.onVisibilityChange);
    }
    const xhr = new XMLHttpRequest();
    xhr.open('GET', '/wechat-open-api/official-account/getJSSDKConfig?' + 'jsApiList=scanQRCode&jsApiList=getNetworkType&url=' + encodeURI(window.location.href));
    xhr.send();
    xhr.addEventListener('load', () => {
      // eslint-disable-next-line no-undef
      wx.config(JSON.parse(xhr.response).data);
      // eslint-disable-next-line no-undef
      wx.ready(() => {
        // ready 触发后桥接可能尚未就绪，稍作延迟再调起
        setTimeout(() => this.startScan(), 300);
      });
    });
  },
  beforeUnmount() {
    document.removeEventListener('visibilitychange', this.onVisibilityChange);
    clearTimeout(this.visibleTimer);
  },
  computed: {},
  methods: {
    startScan() {
      if (!isIOS()) {
        // 安卓：沿用最初验证过的调用——无参数、无回调，调起后立即入队返回。
        // 返回消息会被扫码界面挂起到扫码结束才执行，扫完即回到小程序页，
        // 原生收银流程在其上继续，web-view 与收银台无并发导航
        // eslint-disable-next-line no-undef
        wx.scanQRCode();
        this.backToMiniProgram();
        return;
      }
      // iOS：needResult: 0 时微信原生处理扫码结果，付款码直接弹出支付面板。
      // 不在调起/成功回调时机返回（并发于原生流程的导航是历史各轮问题的
      // 根源）；付款完成后的自动返回由页面重新可见驱动（见 onVisibilityChange）
      this.scanStartedAt = Date.now();
      // eslint-disable-next-line no-undef
      wx.scanQRCode({
        needResult: 0,
        cancel: this.onScanCancel,
        fail: this.onScanFail
      });
    },
    onScanCancel() {
      // 过早到达的取消视为桥接误触发，直接忽略
      if (!this.isRealScanResult()) {
        return;
      }
      this.backToMiniProgram();
    },
    onScanFail() {
      if (!this.isRealScanResult() && !this.scanRetried) {
        // 调起偶发立即失败，延迟重试一次
        this.scanRetried = true;
        setTimeout(() => this.startScan(), 500);
      }
      // 重试仍失败时留在页面，用户可通过“微信扫一扫”按钮手动重试
    },
    onVisibilityChange() {
      if (document.visibilityState !== 'visible') {
        clearTimeout(this.visibleTimer);
        return;
      }
      if (!this.scanStartedAt || !this.isRealScanResult() || this.returning) {
        return;
      }
      // 延迟确认：避开扫码界面与收银台切换瞬间的可见闪断（需长于闪断时长），
      // 不宜再调短，否则可能在原生收银台仍在接管时触发返回
      clearTimeout(this.visibleTimer);
      this.visibleTimer = setTimeout(() => {
        if (document.visibilityState !== 'visible' || this.returning) {
          return;
        }
        this.backToMiniProgram();
      }, 800);
    },
    isRealScanResult() {
      return Date.now() - this.scanStartedAt >= SCAN_MIN_DURATION;
    },
    backToMiniProgram() {
      // 防重入：取消回调与可见性回调可能几乎同时触发，只允许第一次返回生效
      if (this.returning) {
        return;
      }
      this.returning = true;
      // eslint-disable-next-line no-undef
      wx.miniProgram.navigateBack();
    }
  }
};